<script lang="ts">
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import ModalDialog from "@kontextwerk/web-sdk/ui/overlay/ModalDialog.svelte"
  import type { WorkOrderEmployeeFilterOption } from "../../_shared/_logic/work-order-filters"
  import {
    createTourSheetPrintDateRange,
    tourSheetPrintDateRangeError,
    type TourSheetPrintOptions,
  } from "../../_shared/_logic/tour-sheet"

  const { employees, pending, error, onPrint, onClose } = $props<{
    employees: WorkOrderEmployeeFilterOption[]
    pending: boolean
    error: string | null
    onPrint: (options: TourSheetPrintOptions) => void | Promise<void>
    onClose: () => void
  }>()

  let dateRange = $state(createTourSheetPrintDateRange())
  let employeeIds = $state<string[]>([])
  const employeeOptions = $derived(
    employees.map((employee) => ({ value: employee.id, label: employee.label })),
  )
  const dateRangeError = $derived(tourSheetPrintDateRangeError(dateRange))

  const print = () => {
    if (pending || dateRangeError) return

    void onPrint({
      dateRange: { ...dateRange },
      employeeIds: [...employeeIds],
    })
  }
</script>

<ModalDialog appearance="plain" title="Termine drucken" size="small" {onClose}>
  <div class="print-form form">
    <Input
      surfaceTone="light"
      brightBackground={true}
      type="dateRange"
      placeholder="Terminzeitraum"
      dateGranularity="day"
      bind:value={dateRange}
      disabled={pending}
    />
    <Input
      surfaceTone="light"
      brightBackground={true}
      type="select"
      label="Mitarbeiter"
      placeholder="Alle Mitarbeiter"
      multiple={true}
      options={employeeOptions}
      bind:value={employeeIds}
      disabled={pending}
    />
    {#if dateRangeError || error}
      <p class="print-error" role="alert">{dateRangeError ?? error}</p>
    {/if}
  </div>
  {#snippet footerSnippet()}
    <div class="print-actions">
      <CTA darkMode={false} type="tertiaryButton" content="Abbrechen" onClick={onClose} />
      <CTA
        darkMode={false}
        type="primaryButton"
        content={pending ? "PDF wird erstellt..." : "Drucken"}
        disabled={pending || Boolean(dateRangeError)}
        onClick={print}
      />
    </div>
  {/snippet}
</ModalDialog>

<style>
  .print-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .print-error {
    margin: 0;
    color: var(--error-100, #d14343);
  }

  .print-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.6rem;
    width: 100%;
  }
</style>
